import {tokens} from '@packages/utilities/styled';
import {Icon as SpringIcon} from '@packages/systems/spring';

const iconColorToken = SpringIcon.__experimentalTokens.color;

/**
 * @TODO - These styles can be imported from Spring's `ButtonGroup.styles.js` in the future.
 */
export const buttonGroupStyles = {
  position: 'relative',
  flexBasis: '100%',
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: '1fr',
  gridColumnGap: '1px',
  background: '$actionSecondaryBackground',
  boxShadow: tokens.boxShadows.actionSecondary,
  borderRadius: '3px !important',
  padding: '1px !important',
  '[aria-checked][data-focus="true"], [aria-checked]:focus-visible': {
    outlineWidth: '1px !important',
    outlineStyle: 'solid !important',
    outlineOffset: '1px !important',
    outlineColor: '$blueBorder !important',
  },
  '[aria-checked]': {
    [iconColorToken]: `${tokens.colors.textSecondary} !important`,
    background: 'transparent !important',
    color: '$textSecondary !important',
    height: '22px !important',
    borderRadius: '3px !important',
    borderColor: 'transparent !important',
    marginInlineStart: '0px !important',
  },
  '[aria-checked="false"]': {
    boxShadow: 'none !important',
  },
  '[aria-checked="false"]:hover:not([disabled])': {
    [iconColorToken]: `${tokens.colors.actionSecondaryText} !important`,
    background: `${tokens.colors.uiBackgroundHover} !important`,
    color: '$actionSecondaryText !important',
  },
  '[aria-checked="true"]': {
    [iconColorToken]: `${tokens.colors.actionSecondaryText} !important`,
    backgroundColor: '$uiSegmentedControlActive !important',
    boxShadow: tokens.boxShadows.segmentedControl,
    borderRadius: '3px 0 0 3px !important',
    color: '$actionSecondaryText !important',
    '&:first-child': {
      borderTopLeftRadius: '3px !important',
      borderBottomLeftRadius: '3px !important',
    },
    '&:only-child': {
      borderRadius: '3px !important',
    },
  },
  '[aria-checked="true"] + [aria-checked="true"]': {
    borderRadius: '0px !important',
  },
  '[aria-checked="true"]:has(+ [aria-checked="false"])': {
    borderTopRightRadius: '3px !important',
    borderBottomRightRadius: '3px !important',
  },
  '[aria-checked="true"]:last-child': {
    borderTopRightRadius: '3px !important',
    borderBottomRightRadius: '3px !important',
  },
} as const;
